import moment from 'moment'

export const formatDaysToDeliveryDisplay = (productionTime: string | number) => {
  if (productionTime == null) return null

  const parsed =
    typeof productionTime === 'number'
      ? productionTime
      : (() => {
          const match = productionTime.match(/-?\d+(\.\d+)?/)
          return match ? Number(match[0]) : null
        })()

  if (parsed == null || Number.isNaN(parsed)) return null

  const totalBusinessDays = parsed + 5

  // Start from current date in US Eastern time
  const estNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }))
  const cursor = moment(estNow)

  let count = 0
  while (count < totalBusinessDays) {
    cursor.add(1, 'days')
    if (cursor.isoWeekday() <= 5) count++ // 1–5 = Mon–Fri
  }

  return cursor.format('MMM D')
}

/**
 * Converts a number of days into a human-readable relative time string
 * @param numOfDaysPosted - Number of days since posting
 * @returns Formatted string like "X days ago", "X weeks ago", etc.
 */
export function formatTimeAgo(numOfDaysPosted: number): string {
  if (numOfDaysPosted < 7) {
    return `${numOfDaysPosted} ${numOfDaysPosted === 1 ? 'day' : 'days'} ago`
  }

  if (numOfDaysPosted < 30) {
    const weeks = Math.floor(numOfDaysPosted / 7)
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`
  }

  if (numOfDaysPosted < 180) {
    // Less than 6 months (6 * 30 = 180)
    const months = Math.floor(numOfDaysPosted / 30)
    return `${months} ${months === 1 ? 'month' : 'months'} ago`
  }

  // if (numOfDaysPosted < 365) { // More than 6 months but less than a year
  //   return '> 6 months ago';
  // }

  // More than a year
  return '6+ months ago'
}

export const decodeHtml = (str: string) =>
  str
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#039;/g, "'")
    .replace(/&apos;/g, "'")
